// @Version: 1.0.0
export enum FC_ALL_TOGGLE {
   ALLTOGGLEFUNCTION = "allToggleFunction" 
}

export enum TYPE {
   ALLTOGGLEFUNCTION = "all-toggle-function"
}

export enum YESNO {
   YES = "Ja", 
   NO = "No"
}